export const getScheduleRuntimeMode = (settings = {}) => {
  const mode = settings.scheduleRuntimeMode ?? settings.scheduleCalendar?.scheduleRuntimeMode;
  if (mode === "calendar" || mode === "legacy") {
    return mode;
  }
  return "calendar";
};
